export interface HighlightTextProps {
  children: string;
  highlight: string;
}

export function HighlightText({ children, highlight }: HighlightTextProps) {
  if (!children.toLowerCase().includes(highlight.toLowerCase())) {
    return <>{children}</>;
  }

  const indexOfMatch = children.toLowerCase().indexOf(highlight.toLowerCase());

  const start = children.slice(0, indexOfMatch);
  const match = children.slice(indexOfMatch, indexOfMatch + highlight.length);
  const end = children.slice(indexOfMatch + highlight.length);
  return (
    <>
      {start}
      <u>{match}</u>
      <>{end}</>
    </>
  );
}
